import React, { useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import SignupForm from '../user/SignupForm';
import LoginForm from '../user/LoginForm';
import SocialLogin from './SocialLogin';
// import '../../assets/scss/app/blocks/signup-popup.scss';
import '../../assets/scss/app/blocks/new-signup-login.scss';
import { removeBodyScroll } from '../../helper';
import Loader from '../common/Loader';
const SignUpPopup = (props) => {
    const history = useHistory();
    const [toggleForm, setToggleForm] = useState('signup');
    const [isLoading, setIsLoading] = useState(false);
    const gaEvents = (overlay = false) => {
        if(overlay) ga4Track('app_editor_overlay', 'RB App', 'Overlay');
        let ecClose = (toggleForm == 'login' ? 'app_editor_user_closes_login_popup' : 'app_editor_user_closes_signup_popup')
        let elClose = (toggleForm == 'login' ? 'Popup Login Close icon' : 'Popup Signup Close icon')
        ga4Track(ecClose, 'RB App', elClose);
        let ecBounce = (toggleForm == 'login' ? 'app_login_popup_bounces' : 'app_register_popup_bounces')
        let elBounce = (toggleForm == 'login' ? 'Login Popup: Bounces' : 'Register Popup: Bounces')
        ga4Track(ecBounce, 'RB App', elBounce);
    }
    return (<>
        <div className="popup-overlay" onClick={() => {
            gaEvents(true);
            removeBodyScroll(false);
            props.setShowLoginPopUp(false);
        }}></div>
        <div className="user-signup-popup">
            <div className="login-block">
                <div className="close">
                    <span onClick={() => {
                        gaEvents();
                        removeBodyScroll(false);
                        props.setShowLoginPopUp(false);
                    }}><i className="icon-cross-icon"></i></span>
                </div>
                <div className="login">
                    <h3>Welcome to Resume.org </h3>
                    <div className="login-signup-toggle">
                        <div className="toggle-base">
                            <span
                                className={`signup-link  ${toggleForm == 'signup' ? 'active' : ''}`}
                                onClick={() => {
                                    setToggleForm('signup');
                                }}>
                                Sign Up
                            </span>
                            <span
                                className={`login-link ${toggleForm == 'login' ? 'active' : ''}`}
                                onClick={() => {
                                    setToggleForm('login');
                                }}>
                                Log In
                            </span>
                        </div>
                    </div>
                    <SocialLogin 
                        label={toggleForm == 'login' ? 'Login' : 'Sign up'}
                        redirect={history.location.pathname} 
                        type={'popup'}
                        setShowLoginPopUp={props.setShowLoginPopUp}
                        setIsLoading={setIsLoading}
                        setEntities={props?.setEntities ? (r) => props.setEntities(r) : undefined}
                    />
                    {toggleForm == 'login' ? <LoginForm 
                        redirect={window.location.pathname} 
                        type={'popup'} 
                        setShowLoginPopUp={props.setShowLoginPopUp} 
                        setEntities={props?.setEntities ? (r) => props.setEntities(r) : undefined} 
                        setIsLoading={setIsLoading}
                    /> : ''}
                    {toggleForm == 'signup' ? <SignupForm 
                        redirect={window.location.pathname} 
                        type={'popup'} setShowLoginPopUp={props.setShowLoginPopUp} 
                        setEntities={props?.setEntities ? (r) => props.setEntities(r) : undefined}
                        setIsLoading={setIsLoading}
                    /> : ''}
                    {isLoading && <div className="fade-screen">
                        <Loader 
                            className="set-loader" 
                            text={toggleForm == 'login' ? `Logging in...` : `Registering...`} 
                            imageColor="white"
                        />
                    </div>}
                </div>
            </div>
        </div>
    </>);
}

export default SignUpPopup;